"use client";

import { featureFlags } from "#/config/featureFlags";
import { useIsTopBannerDismissed } from "#/store/app/alerts/isTopBannerDismissed";
import { TopBannerFeatureFlag } from "#/types/featureFlags";

import { useFeatureFlags } from "./useFeatureFlags";

export const useTopBannerFeatureFlag = () => {
  const { isTopBannerDismissed } = useIsTopBannerDismissed();
  const { isEnabled, title, isDismissible } =
    useFeatureFlags<TopBannerFeatureFlag>(featureFlags.topBanner) ?? {
      isEnabled: false,
    };

  return {
    showTopBanner: isEnabled && !isTopBannerDismissed,
    title,
    isEnabled,
    isDismissible,
  };
};
